module.exports = __webpack_public_path__ + "img/error.700bd717.svg";